import { useContext } from 'react';

import { isUndefined } from 'Utilities/helpers';
import { useFeatureFlags } from 'Utilities/hooks';

import { APIResponseStatus } from 'Services/api.types';

import { useSaleDetailsSub } from '../vehicleCollection/hooks/useSaleDetailsSub';
import { SELLER } from '../vehicleProfiling/VehicleProfiling.constants';

import { isNewCoreDocsEnquiry } from './DocumentCapture.helpers';
import { DocumentCaptureConfirmationProgressContext, DocumentCaptureOfferContext } from './DocumentCaptureContexts';

export const useDocumentCaptureExperimentDecisions = () => {
  const { incodeEnabled } = useFeatureFlags();
  const { data } = useContext(DocumentCaptureOfferContext) || {};
  const {
    progress: {
      bankDetailsAdded,
      bankDetailsReviewFailed,
      documents,
    },
  } = useContext(DocumentCaptureConfirmationProgressContext) ?? {};
  const { hasNegativeEquity, offerStatus } = useSaleDetailsSub();

  const noDocsYet = isNewCoreDocsEnquiry({ documents });
  const isV5LogBookOwnedBySeller = data?.seller?.keeperType === SELLER;
  const isOnFinance = data?.finance?.isVehicleOnFinance;
  const hasValidBankDetails = bankDetailsAdded === true && !bankDetailsReviewFailed;

  if (isUndefined(data) || isUndefined(documents) || offerStatus !== APIResponseStatus.SUCCESS) {
    return {
      isIncodeEligible: false,
      isMandatoryBankDetailsEligible: false,
    };
  }

  const isIncodeEligible = incodeEnabled
    && isV5LogBookOwnedBySeller
    && noDocsYet
    && hasValidBankDetails
    && !isOnFinance;

  const isMandatoryBankDetailsEligible = (!incodeEnabled || !isV5LogBookOwnedBySeller)
    && !documents?.some(({ uploaded }) => (!!uploaded))
    && !hasValidBankDetails
    && !hasNegativeEquity;

  return {
    isIncodeEligible,
    isMandatoryBankDetailsEligible,
  };
};
